module.exports = __webpack_public_path__ + "img/hzLogo4.751e011d.png";